import API from './api';
import router from '@/router';

export default {
  fetchTrackingsByStudent() {
    return API().get(`students/${router.currentRoute.params.id}/trackings`);
  },
  addTrackingRecord(params) {
    return API().post(
      `students/${router.currentRoute.params.id}/trackings`,
      params
    );
  },
  updateTrackingRecord(params) {
    return API().put(
      `students/${router.currentRoute.params.id}/trackings/${params.id}`,
      params
    );
  },
  deleteTrackingRecord(params) {
    return API().delete(
      `students/${router.currentRoute.params.id}/trackings/${params}`
    );
  },
};
